// cr media 媒體
import CRMediaSwiperWrap from "./CRMediaSwiperWrap";
import CRMediaTitle from "./CRMediaTitle";
import CRMediaDescription from "./CRMediaDescription";

const CRMedia = () => {
    return(
        <section id="cr-media" className="cr-section cr-media w-full
            flex justify-end items-center relative top-0 right-[3%]
            asm:w-[1440px] asm:h-screen pt-[0px]
            usm:pt-[200px] usm:right-0 usm:left-0 usm:m-auto
        ">
            <div id="cr-media-text" className="cr-media-text relative w-[60%] h-[fit-content] flex-shrink-0 z-[1] usm:w-full usm:px-[16px]">
                <div className="cr-media-text-wrap flex flex-col items-center gap-y-[25px] overflow-hidden w-full max-w-[756px] mx-auto">

                    {/* title 圖片 */}
                    <CRMediaTitle />

                    {/* 文字描述 */}
                    <CRMediaDescription />

                    {/* 媒體輪播 */}
                    <CRMediaSwiperWrap />

                </div>
            </div>

        </section>
    )
}

export default CRMedia;

